import { useReferralUrl } from '../../hooks/useReferralUrl';
import FormPageLayout from './FormPageLayout';
import Form from './RewampedLanding/Form';

export const AcquirePage: React.FC = (): JSX.Element => {
  useReferralUrl();

  return (
    <FormPageLayout
      title="Let’s Help You Acquire This Domain | Saw.com"
      heading="Let’s help you acquire this domain"
      subtitle="Fill out the form and our domain experts will get in touch with you."
    >
      <Form />
    </FormPageLayout>
  );
};

export default AcquirePage;
